import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateagoPipe } from '../pipes/dateago.pipe';

@NgModule({
  declarations: [    DateagoPipe
  ],
  imports: [
    CommonModule,
  ],
  exports:[
    DateagoPipe
  ]
})
export class DateModule { }
